import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { formatPeopleCount } from '~/utils/helpers';

import { PeopleCountText } from './PeopleCountLine.styles';
import { PulsePeopleCount } from './usePulsePeopleCount';

interface Props {
  peopleCount: PulsePeopleCount;
}

const PeopleCountLine = ({ peopleCount }: Props): JSX.Element => {
  const { t } = useTranslation();
  return <PeopleCountText>{peopleCountLabel(peopleCount, t)}</PeopleCountText>;
};

// `loading` wins over the previous count, so every edit visibly registers before the number moves.
const peopleCountLabel = (peopleCount: PulsePeopleCount, t: TFunction): string => {
  if (peopleCount.loading) return t('aiInsights.a2ui.peopleCount.loading');
  if (peopleCount.failed) return t('aiInsights.a2ui.peopleCount.error');
  return t('aiInsights.a2ui.peopleCount.total', { total: formatPeopleCount(peopleCount.totalCount ?? 0) });
};

export default PeopleCountLine;
